import Quill from 'quill'
import {appParams} from '../../../../models/apps/app-parameters'
import {getRandomId} from '../../../../utils'
import {MAP_PARAM_OBJECT_FIELD_NAME, MAP_PARAM_OBJECT_ID, MAP_PARAM_OBJECT_TAG} from '../index'
import {WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE} from '../../../../models/workflow'

const Parchment = Quill.imports.parchment

// const Delta = Quill.imports.delta

export class MapParamObjectTag extends Parchment.Embed {
    static tagName = 'span'
    static blotName = MAP_PARAM_OBJECT_TAG
    static className = MAP_PARAM_OBJECT_TAG

    // eslint-disable-next-line no-useless-constructor
    constructor(domNode) {
        super(domNode)
        // domNode.addEventListener('click', this.clickHandler)
    }

    static register() {
        Quill.register(MapParamObjectTag)
    }

    static create({workflowObject = {}, fieldsChain = []}) {
        let isObject = true
        if (fieldsChain.length !== 0) {
            const paramModel = appParams[fieldsChain[fieldsChain.length - 1].type]
            isObject = paramModel ? [Object.name, Array.name].includes(paramModel.type) : false
        }
        let text = ''
        if (workflowObject.label) {
            text = `@${workflowObject.label}`
        }

        if (fieldsChain.length !== 0) {
            text += '.' + fieldsChain.map(f => f.label).join('.')
        }

        const node = super.create(text)
        node.id = getRandomId('tag')
        node.innerText = text
        node.contentEditable = 'false'
        if (workflowObject.type === WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE) {
            node.style.backgroundColor = '#dc3545'
            node.style.color = 'white'
        } else {
            node.style.backgroundColor = isObject ? '#ECF9EE' : '#85149b1a'
        }
        node.dataset[_.camelCase(MAP_PARAM_OBJECT_ID)] = workflowObject.id
        for (let i = 0; i < fieldsChain.length; i++) {
            let field = fieldsChain[i]
            node.dataset[_.camelCase(MAP_PARAM_OBJECT_FIELD_NAME) + i] = field.name
        }
        // this.addRemovalButton(node)
        return node
    }

    static value(node) {
        return node.childNodes[0].textContent
    }

// clickHandler(event) {
// console.log('click blot: ', this);
// }

// static addRemovalButton(node) {
//     const button = document.createElement('span')
//     button.innerText = '✕'
//     button.className = 'object-tag-remove-btn'
//     button.onclick = () => node.remove()
//     button.contentEditable = 'false'
//     node.appendChild(button)
//
//     // Extra span forces the cursor to the end of the label, otherwise it appears inside the removal button
//     const span = document.createElement('span')
//     span.innerText = ' '
//     node.appendChild(span)
// }
}
